import React from "react";
import { Layers, TrendingUp, Package, Columns3, CheckCircle2, Share2 } from "lucide-react";

const iconMap = [
  <Layers className="h-10 w-10" />, 
  <TrendingUp className="h-10 w-10" />, 
  <Package className="h-10 w-10" />, 
  <Columns3 className="h-10 w-10" />, 
  <CheckCircle2 className="h-10 w-10" />, 
  <Share2 className="h-10 w-10" />, 
];

const potentialData = [
  {
    name: "Agile Methodology",
    description:
      "We deliver value fast and adapt to change with agile, iterative development cycles and continuous feedback.",
  },
  {
    name: "Scalability",
    description:
      "Our solutions are designed to scale with your business, supporting growth from MVP to enterprise level.",
  },
  {
    name: "Rich Ecosystem",
    description:
      "We leverage a vast ecosystem of libraries, frameworks, and integrations to accelerate delivery and innovation.",
  },
  {
    name: "Modular Architecture",
    description:
      "Our modular, component-based approach ensures maintainability, flexibility, and rapid feature development.",
  },
  {
    name: "Built-In Quality",
    description:
      "Automated testing, code reviews, and CI/CD pipelines ensure robust, reliable, and high-quality software.",
  },
  {
    name: "API-First Approach",
    description:
      "We design API-first systems for seamless integration, extensibility, and future-proof digital products.",
  },
];

const OurPotential = () => {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <div className="flex items-center justify-center space-x-2 mb-4">
            <div className="w-8 sm:w-10 h-0.5 bg-corporate-accent"></div>
            <span className="text-corporate-title font-semibold text-base sm:text-lg tracking-wide">
              Discover our potential
            </span>
            <div className="w-8 sm:w-10 h-0.5 bg-corporate-accent"></div>
          </div>
          <h2 className="heading">
            Agile & Modern <span>Software Development</span>
          </h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {potentialData.map((item, idx) => (
            <div
              key={item.name}
              className="bg-white p-6 rounded-lg shadow hover:shadow-lg transition-all duration-300 text-center group"
            >
              <div className="mb-6 flex justify-center">
                <span className="inline-flex items-center justify-center h-16 w-16 rounded-full bg-white">
                  {React.cloneElement(iconMap[idx], {
                    style: { stroke: 'url(#potential-gradient)', strokeWidth: 2 },
                  })}
                  <svg width="0" height="0">
                    <defs>
                      <linearGradient id="potential-gradient" x1="0" y1="0" x2="1" y2="1">
                        <stop offset="0%" stopColor="#ca262c" />
                        <stop offset="100%" stopColor="#a01f24" />
                      </linearGradient>
                    </defs>
                  </svg>
                </span>
              </div>
              <h3 className="text-xl font-semibold text-corporate-gray-dark mb-3">
                {item.name}
              </h3>
              <p className="text-corporate-gray mb-4 leading-relaxed">
                {item.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default OurPotential;
